module.exports = __webpack_public_path__ + "static/img/Hualien-econstruction_02.1107503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/Hualien-econstruction_02.jpg
// module id = Aw/s
// module chunks = 100